import type { SiteControllerSettingBeds24Input } from "@/lib/gql/__generated__/graphql";

import type { SiteControllerSettingBeds24FormModel } from "../../../type";

type Props = {
	viewModel: SiteControllerSettingBeds24FormModel["ViewModel"];
};
export const viewModelToInput = ({ viewModel }: Props) => {
	const {
		hotelID,
		beds24AuthenticationApiKey,
		beds24AuthenticationPropKey,
		beds24RoomTypeMapping,
		setUpRoomPriceByChillnn,
	} = viewModel;

	const input: SiteControllerSettingBeds24Input = {
		hotelID,
		beds24AuthenticationApiKey: beds24AuthenticationApiKey?.value,
		beds24AuthenticationPropKey: beds24AuthenticationPropKey.value,
		beds24RoomTypeMapping: beds24RoomTypeMapping.value.map((item) => {
			return {
				beds24roomID: item.beds24roomID.value,
				beds24AuthenticationPropKey: item.beds24AuthenticationPropKey?.value,
				roomID: item.roomID?.value,
			};
		}),
		setUpRoomPriceByChillnn: setUpRoomPriceByChillnn?.value,
	} satisfies SiteControllerSettingBeds24Input;

	return input;
};
